import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import { BottomNav } from './BottomNav';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { activeClub } = useTenant();
  const location = useLocation();

  const isPickClubRoute = location.pathname === '/pick-club';

  return (
    <div className="layout">
      <main className="layout-main">{children}</main>
      {isAuthenticated && activeClub && !isPickClubRoute && <BottomNav />}
    </div>
  );
};
